import { render, staticRenderFns } from "./AdminScheduler.vue?vue&type=template&id=3b7126d8&lang=pug"
import script from "./AdminScheduler.vue?vue&type=script&lang=js"
export * from "./AdminScheduler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SummaryCard: require('/home/docker/code/frontend/components/SummaryCard.vue').default})
